export function countTruthy(values) {
    return values.reduce((sum, value) => sum + (value ? 1 : 0), 0);
}

export function isFunctionNative(func) {
    return /^function\s.*?\{\s*\[native code]\s*}$/.test(String(func));
}

export function isPromise(value) {
    return !!value && typeof value.then === 'function';
}

export function suppressUnhandledRejectionWarning(promise) {
    promise.then(undefined, () => undefined);
    return promise;
}

export function wait(durationMs, resolveWith) {
    return new Promise(resolve => setTimeout(resolve, durationMs, resolveWith));
}